// extracted by mini-css-extract-plugin
export default {"container":"loader__container___UY_fA","spinner":"loader__spinner___hGkM_","spin":"loader__spin___wEtaQ"};